import type { ZodSchema } from "zod"

import type { GID } from "@unlikelystudio/commerce-connector"

import type { Nullish } from "~/@types/generics"
import { serializeMetaobject } from "~/lib/shopify/metaobjects/serializer"
import { getSfMetaobject } from "~/lib/shopify/queries/get-sf-metaobject"

export async function getMetaObjects<Schema extends ZodSchema>(
  ids: Nullish<GID[]>,
  schema: Schema,
  locale: Nullish<string>
) {
  return (
    (
      await Promise.all(
        ids?.map(async (id) => {
          const { metaobject } = await getSfMetaobject({ id, locale })

          return serializeMetaobject(schema, metaobject)
        }) ?? []
      )
    ).filter(Boolean) ?? []
  )
}
